import dayjs from 'dayjs';

/** Calendar year while the parent is completing the form. */
export const currentYear = () => dayjs().year();

/** School year they are re-enrolling into. */
export const reenrolmentYear = () => dayjs().add(1, 'year').year();
